import { render, staticRenderFns } from "./failReason.vue?vue&type=template&id=6e583f96&scoped=true"
import script from "./failReason.vue?vue&type=script&lang=js"
export * from "./failReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e583f96",
  null
  
)

export default component.exports